/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.FeatureStoreUsageRpc
 */

export const getLimitUsageForHubRpc = {
  serviceName: 'com.hubspot.feature.store.rpc.FeatureStoreUsageRpc',
  rpcName: 'getLimitUsageForHub',
  auth: 'app',
  fingerprint: 'WQ1ViXIsmZqRv4WbZk_P-BkG0YqqRuYE',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLimitParcelMappingsRpc = {
  serviceName: 'com.hubspot.feature.store.rpc.FeatureStoreUsageRpc',
  rpcName: 'getLimitParcelMappings',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABo2wjYQpk3DhkG0YqqRuYE',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};